const stats = [
  { value: '1992', label: 'Gegründet', icon: 'ri-building-line' },
  { value: '30+', label: 'Jahre Erfahrung', icon: 'ri-award-line' },
  { value: '500+', label: 'Realisierte Projekte', icon: 'ri-tools-line' },
  { value: '24h', label: 'Reaktionszeit', icon: 'ri-time-line' },
];

const values = [
  {
    icon: 'ri-user-heart-line',
    title: 'Inhabergeführt & persönlich',
    description:
      'Als Einzelunternehmen unter der Leitung von Hans-Jörg Gollan stehen wir persönlich für jedes Projekt ein. Kein Callcenter, kein Weitervermitteln – Sie sprechen direkt mit dem Experten.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Maßgeschneiderte Lösungen',
    description:
      'Keine Standardlösungen von der Stange. Jede Anlage, jede Steuerung, jedes System wird individuell auf Ihre Produktionsprozesse und Anforderungen abgestimmt.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Zuverlässig & termintreu',
    description:
      'Termintreue, transparente Kommunikation und nachhaltige Qualität – darauf können Sie sich bei gowiTEC verlassen. Wir liefern, was wir versprechen.',
  },
  {
    icon: 'ri-global-line',
    title: 'Projekte in ganz Europa',
    description:
      'Unsere Kunden kommen aus dem gesamten deutschsprachigen Raum und Europa. Ob Mittelstand oder Großindustrie – wir sind dort, wo Sie uns brauchen.',
  },
];

const CompanyValues = () => {
  return (
    <>
      {/* Stats */}
      <section className="bg-[#1E3A8A] py-14">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-white/70 text-2xl`}></i>
                </div>
                <div className="text-white text-4xl font-bold mb-1">{stat.value}</div>
                <div className="text-blue-200 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-16">
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Unsere Werte</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">
              Warum gowiTEC?
            </h2>
            <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
              Technik mit Handschlagqualität – wir verbinden technische Exzellenz mit persönlichem Engagement.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {values.map((val) => (
              <div key={val.title} className="bg-white rounded-xl p-8 border border-gray-100 hover:border-[#1E3A8A]/20 transition-colors duration-200">
                <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl mb-5">
                  <i className={`${val.icon} text-[#1E3A8A] text-xl`}></i>
                </div>
                <h3 className="text-gray-900 font-semibold text-lg mb-3">{val.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{val.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyValues;
